<template>
    <div class="relative w-[14px] h-[14px]">
        <BasicIcon
            name="chat"
            :size="size"
        />
        <div
            v-if="unreadMessagesAmount > 0"
            :class="messagesBadgeStyles"
            data-testId="unread-messages-badge"
            class="w-[14px] h-[14px] absolute top-0 right-[-8px] bg-error text-font-4 rounded-full flex items-center justify-center"
        >
            {{ amountToDisplay }}
        </div>
    </div>
</template>

<script setup lang="ts">
import BasicIcon from '@atoms/BasicIcon/BasicIcon.vue';
import { useChatMessagesAmountBadge } from '@composables/useChatMessagesAmountBadge';
import type { Size } from '@atoms/BasicIcon/sizes';

export type ChatIconProps = {
    unreadMessagesAmount: number;
    size?: Size;
};

const props = withDefaults(defineProps<ChatIconProps>(), { size: '14' });

const { amountToDisplay, messagesBadgeStyles } = useChatMessagesAmountBadge(
    toRef(() => props.unreadMessagesAmount)
);
</script>
